import { AppConstants } from '../application-constants'

export const OAUTH_REDIRECT_ROUTE = '/oauth2/redirect'
export const OAUTH2_REDIRECT_URI = `${AppConstants.oAuthHostUrl}${OAUTH_REDIRECT_ROUTE}`
export const GOOGLE_AUTH_URL = `${AppConstants.dataUrl}/oauth2/authorize/google?redirect_uri=${OAUTH2_REDIRECT_URI}`
export const FACEBOOK_AUTH_URL = `${AppConstants.dataUrl}/oauth2/authorize/facebook?redirect_uri=${OAUTH2_REDIRECT_URI}`
export const GITHUB_AUTH_URL = `${AppConstants.dataUrl}/oauth2/authorize/github?redirect_uri=${OAUTH2_REDIRECT_URI}`
